import React from 'react';
import { Navigate } from 'react-router-dom';

function FeatureRoute({ canAccess, children }) {
  if (!canAccess) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default FeatureRoute;
